<section class="section-white">
  <section class="section-container">
    <span class="product-blog-subheading mar-b-16 align-c">{{
      digitalPlatformData?.tags?.[0]?.fields?.tagText
    }}</span>
    <h2 class="section-heading mar-b-32">{{ digitalPlatformData?.title }}</h2>
    <div class="section-description mar-b-48 align-c">
      <div
        class="wid-50"
        [innerHtml]="digitalPlatformData?.content | toHtml"
      ></div>
    </div>
    <div class="financial-stack moonstone-100 align-l">
      <div class="product-hero-content-box">
        <div>
          <h2 class="discover-power-heading mar-b-32 align-l">
            {{ internationalPayoutApiContent?.[0]?.fields?.title }}
          </h2>
          <div
            class="section-description mar-b-32 align-l"
            [innerHtml]="
              internationalPayoutApiContent?.[0]?.fields?.description | toHtml
            "
          ></div>
        </div>
        <img
          src="{{
            internationalPayoutApiContent?.[0]?.fields?.imageicon?.fields?.file
              ?.url
          }}"
          loading="lazy"
        />
      </div>
    </div>
    <div class="bottom-cards">
      <div class="section-efficient-payment">
        <ng-container *ngFor="let content of apiContent; let i = index">
          <div
            class="efficient-payment"
            [ngClass]="
              i === 0
                ? 'padd-32 blue-100'
                : i === 1
                  ? 'padd-32 orange-100'
                  : i === 2
                    ? 'padd-32 green-100'
                    : ''
            "
          >
            <div
              class="product-landing-content"
            >
              <h5 class="efficient-payment-heading">
                {{ content?.fields?.title }}
              </h5>
              <div
                class="efficient-payment-description"
                [innerHtml]="content?.fields?.description | toHtml"
              ></div>
            </div>
            <figure>
              <img
                loading="lazy"
                src="{{ content?.fields?.imageicon?.fields?.file?.url }}"
              />
            </figure>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</section>
